enum ExportCopartPreviewCSVFileStatusEnum {
  PROCESSED = 'Processed',
  PROCESSING = 'Processing',
  PROCESS = 'Process',
  ERROR = 'Error',
}

interface ExportCopartPreviewCSVFileResponseDTO {
  content: {
    status: ExportCopartPreviewCSVFileStatusEnum;
  };
}

interface GetExportCopartPreviewCSVFileResponseDTO {
  content: {
    status: ExportCopartPreviewCSVFileStatusEnum;
    message?: string;
    downloadLink?: string;
  };
}

interface ExportCopartPreviewCSVFileRequestDTO {
  partnerCompany: string;
}

export {
  GetExportCopartPreviewCSVFileResponseDTO,
  ExportCopartPreviewCSVFileStatusEnum,
  ExportCopartPreviewCSVFileResponseDTO,
  ExportCopartPreviewCSVFileRequestDTO,
};
